require("!!/opt/app/develop/node_modules/script-loader/addScript.js")(require("!!/opt/app/develop/node_modules/raw-loader/index.js!/opt/app/develop/node_modules/source-map-loader/index.js!/opt/app/develop/src/assets/js/app.js"))


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/script-loader!/opt/app/develop/src/assets/js/app.js
// module id = ../../../../script-loader/index.js!../../../../../src/assets/js/app.js
// module chunks = 3